import React from "react";
import { Link, useHistory } from "react-router-dom";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";
import { Api } from "./../app-controller.js";
import { useAuth } from "../components/content/auth.jsx";
import Swal from "sweetalert2";
import Select from "react-select";
//import Button from "@material-ui/core/Button";

const hiddenFileInput = React.createRef(null);

const colourStyles = {
  input: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  control: (styles) => ({
    ...styles,
    border: 0,
    boxShadow: "none", // This line disable the blue border
    backgroundColor: "#656565",
    color: "#fff",
  }),
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  noOptionsMessage: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
      backgroundColor: "#000",
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: "#000",
      color: "#FFF",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "#1978E2",
      },
    };
  },
};

class RegentInscription extends React.Component {
  initialState = {
    nombres: "",
    apellido_paterno: "",
    apellido_materno: "",
    solicitudes_aceptadas: "",
    solicitudes: [],
    options: Api.loadCatalogue("locations"),
    options_professions: [], //{ profesiones: Api.loadCatalogue("cat_profesion") },
    options_regent: { tipo_regente: Api.loadCatalogue("cat_tipo_regente") },
    options_identification: {
      tipo_identificacion: Api.loadCatalogue("cat_tipo_documento"),
    },
    options_documents: [], //Api.loadCatalogue("cat_tipo_documento"),
    options_action: [],
    licencias: [],
    tipo_regente_id: "",
    departamento_id: "",
    municipio_id: "",
    tramite_id: "",
    profesion_id: "",
    professions: [],
    accion_id: "",
    licencia_id: "",
    direccion: "",
    tipo_documento_id: "",
    numero_identificacion: "",
    street: "",
    correo_electronico: "",
    telefono_convencional: "",
    telefono_celular: "",
    identificacion_id: "",
    codigo_ipsa: "",
    documentos: [],
    document_type_temp: 0,
    procesando: false,
    no_nuevo: 0,
    docsRequired: [],
    recs: 0,
    isGoing: false,
    disabled: false,
    solicitud_id: "",
    regente_id: "",
    autoFill: false,
    codigo_ipsa_validado: false,
    codigo_ipsa_btn: false,
    fecha_regente_vencida: false,
    codigo_ipsa_existe: false,
    solicitudesLRV: "",
    solicitudesLRA: "",
    nivelUsuario: localStorage.nivel_actual,
  };

  state = this.initialState;

  documentos = [];

  constructor(props) {
    super(props);

    if (props.auth.user.name === undefined) {
      this.props.history.push("login");
    }

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDepartamentos = this.handleDepartamentos.bind(this);
    this.handleMunicipios = this.handleMunicipios.bind(this);
    this.handleIndentificacion = this.handleIndentificacion.bind(this);
    this.handleTipoRegente = this.handleTipoRegente.bind(this);
    this.handleProfesion = this.handleProfesion.bind(this);
    this.handleTipoDocumento = this.handleTipoDocumento.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleTipoAccion = this.handleTipoAccion.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.autoRellenar = this.autoRellenar.bind(this);
    this.handleLicencia = this.handleLicencia.bind(this);
    this.handleCorrection = this.handleCorrection.bind(this);
    this.handleCamposEditables = this.handleCamposEditables.bind(this);
    this.maxLengthCheck = this.maxLengthCheck.bind(this);
    this.handleNumIdentificacion = this.handleNumIdentificacion.bind(this);
    this.handleTelefonoConvencional =
      this.handleTelefonoConvencional.bind(this);
    this.handleTelefonoCelular = this.handleTelefonoCelular.bind(this);
    this.validatePhoneNumber = this.validatePhoneNumber.bind(this);
    this.verifyCodigoIPSA = this.verifyCodigoIPSA.bind(this);
    this.cleanErrorsValidation = this.cleanErrorsValidation.bind(this);
    this.handleValidationInput = this.handleValidationInput.bind(this);
  }

  componentDidMount() {
    // si el usuario no es nivel cliente redireccionamos a home
    if (this.state.nivelUsuario !== "1") {
      window.location.href = "/";
    }

    let identificacion = Api.loadCatalogue("cat_tipo_documento");
    let ids = [];
    for (let id in identificacion) {
      if (identificacion[id].id === "1" || identificacion[id].id === "2") {
        ids.push(identificacion[id]);
      }
    }
    this.setState({ options_identification: { tipo_identificacion: ids } });
    this.autoRellenar();
  }

  handleDepartamentos(e) {
    this.setState({ departamento_id: e.target.value });
  }

  handleMunicipios(e) {
    this.setState({ municipio_id: e.target.value }, () => {});
  }

  verifyCodigoIPSA(e) {
    this.cleanErrorsValidation("codigo_ipsa_input");
    this.setState({ codigo_ipsa_btn: true });
    // verificamos si el codigo ipsa se encuentra vació
    if (!this.state.codigo_ipsa) {
      this.handleValidationInput(
        "codigo_ipsa_input",
        "is-invalid",
        "invalid-feedback",
        "Ingrese código DISAAN."
      );
      this.setState({
        codigo_ipsa_validado: this.initialState.codigo_ipsa_validado,
      });
      return false;
    }

    // si no lo está, verificamos el código en la api
    Api.loading(true);
    Api.fetch(
      "app/verifyCodigoIPSA?codigo_ipsa=" + this.state.codigo_ipsa
    ).then((data) => {
      Api.loading(false);
      // si regresa un objeto vació quiere decir que es inválido
      if (Object.entries(data).length === 0) {
        this.handleValidationInput(
          "codigo_ipsa_input",
          "is-invalid",
          "invalid-feedback",
          "Código DISAAN Inválido."
        );
        this.setState({
          codigo_ipsa_validado: this.initialState.codigo_ipsa_validado,
        });
      } else if (data.fecha_caducada) {
        this.handleValidationInput(
          "codigo_ipsa_input",
          "is-invalid",
          "invalid-feedback",
          "Fecha de código DISAAN vencida."
        );

        this.setState({
          fecha_regente_vencida: true,
          codigo_ipsa_validado: true,
          codigo_ipsa_existe: this.initialState.codigo_ipsa_existe,
        });
      } else if (data.codigo_existe) {
        this.handleValidationInput(
          "codigo_ipsa_input",
          "is-invalid",
          "invalid-feedback",
          "El código DISAAN ya se encuentra registrado con licencia de regente activa."
        );

        this.setState({
          codigo_ipsa_existe: true,
          fecha_regente_vencida: this.initialState.fecha_regente_vencida,
          codigo_ipsa_validado: true,
        });
      } else {
        // si regresa un objeto con propiedades es por que es válidado
        this.handleValidationInput(
          "codigo_ipsa_input",
          "is-valid",
          "valid-feedback",
          "Código DISAAN válido."
        );
        this.setState({
          codigo_ipsa_validado: true,
          codigo_ipsa_existe: this.initialState.codigo_ipsa_existe,
          fecha_regente_vencida: this.initialState.fecha_regente_vencida,
        });
      }
    });
  }

  handleValidationInput(elemento, estado, feedback, msg) {
    document.getElementById(elemento).classList.add(estado);
    document.getElementById(`${elemento}-msg`).classList.add(feedback);
    document.getElementById(`${elemento}-msg`).style.display = "block";
    document.getElementById(`${elemento}-msg`).innerText = msg;
  }

  handleTipoRegente(e) {
    let aux_ipsa = this.initialState.codigo_ipsa;

    if (e.target.value == "1") {
      this.cleanErrorsValidation("codigo_ipsa_input");
      
      if(this.state.codigo_ipsa !== null){
        aux_ipsa = this.state.codigo_ipsa;
      }

      this.setState({
        codigo_ipsa_validado: this.initialState.codigo_ipsa_validado,
        codigo_ipsa_btn: this.initialState.codigo_ipsa_btn,
        codigo_ipsa: aux_ipsa,
        fecha_regente_vencida: this.initialState.fecha_regente_vencida,
        codigo_ipsa_existe: this.initialState.codigo_ipsa_existe,
      });
    }

    this.setState({
      tipo_regente_id: e.target.value,
      tramite_id: e.target.value,
      tipo_regente: e.target.value,
    });

    Api.fetch(
      "cat/getProfesionesTipoRegente?tipo_regente=" + e.target.value
    ).then((data) => {
      if (data) {
        this.setState({ options_professions: data.profesiones });
      }
    });

    Api.fetch("cat/getActionType?tramite_id=" + e.target.value).then(
      (data) => {
        if (data) {
          this.setState({ options_action: data });
        }
      }
    );
  }

  handleNumIdentificacion(evt) {
    this.setState({ numero_identificacion: evt.target.value });
  }

  handleCamposEditables(correccion = false) {
    const $tid = document.getElementById("tid"),
      $nid = document.getElementById("nid"),
      $telefonoConvecional = document.getElementById("telefono_convencional"),
      $direccion = document.getElementById("direccion");
      //$codigoIPSA = document.getElementById("codigoIPSA");
      //$codigoIPSA = document.getElementById("codigo_ipsa_input");

    if (this.state.solicitudes_aceptadas > 0 || correccion) {
      $tid.setAttribute("disabled", true);
      $nid.setAttribute("disabled", true);
      $telefonoConvecional.setAttribute("disabled", true);
      $direccion.setAttribute("disabled", true);
    } else {
      $tid.removeAttribute("disabled");
      $nid.removeAttribute("disabled");
      $telefonoConvecional.removeAttribute("disabled");
      $direccion.removeAttribute("disabled");
    }

/*     if (this.state.solicitudesLRV > 0 || correccion) {
      $codigoIPSA.setAttribute("disabled", true);
    } else {
      $codigoIPSA.removeAttribute("disabled");
    } */
  }

  handleTelefonoConvencional(evt) {
    if (this.validatePhoneNumber(evt.target.value)) {
      this.setState({ telefono_convencional: evt.target.value });
    }
  }

  handleTelefonoCelular(evt) {
    if (this.validatePhoneNumber(evt.target.value)) {
      this.setState({ telefono_celular: evt.target.value });
    }
  }

  validatePhoneNumber(char) {
    let regex = /^[0-9]{1,8}$/;

    if (char === "" || regex.test(char)) {
      return true;
    }

    return false;
  }

  handleTipoAccion(e) {
    this.setState({ accion_id: e.target.value });
    //let accion = 0;
    if (this.state.accion_id === "1" || this.state.accion_id === "2") {
      //alta o renovacion
      //accion = 1;
    } else if (
      this.state.accion_id === "2002" ||
      this.state.accion_id === "3002"
    ) {
      //baja o reposicion
      //accion = 2;
    }

    console.log(this.state);

    /* var accion_name;
    this.state.options_action.forEach((element) => {
      if (e.target.value === element.value) {
        accion_name = element.label;
      }
    }); */

    Api.fetch(
      "cat/getDocsPorTramite?tramite_id=" +
        this.state.tramite_id +
        "&accion_id=" +
        e.target.value
    ).then((data) => {
      if (data) {
        this.setState({ options_documents: data });
      }
    });

    Api.fetch(
      "cat/getDocsObligatorios?tramite_id=" +
        this.state.tramite_id +
        "&accion_id=" +
        e.target.value
    ).then((data) => {
      if (data) {
        this.setState({ docsRequired: data });
      }
    });

    if (e.target.value === "2") {
      //renovacion
      Api.loading(true);
      Api.fetch(
        "app/getRegenteRenovacion?tramite_id=" + this.state.tramite_id
      ).then((r) => {
        this.setState({ tramite_id: r.tipo_regente });

/*         Api.fetch(//ya no es necesario por que en renvacion no se puede mover el select de profesiones
          "cat/getProfesionesTipoRegente?tipo_regente=" + r.tipo_regente
        ).then((data) => {
          if (data) {
            this.setState({ options_professions: data.profesiones });
          }
        }); */

        Api.fetch(
          "cat/getDocsPorTramite?tramite_id=" +
            r.tipo_regente +
            "&accion_id=" +
            this.state.accion_id
        ).then((data) => {
          if (data) {
            this.setState({ options_documents: data });
          }
        });

        Api.fetch(
          "cat/getDocsObligatorios?tramite_id=" +
            r.tipo_regente +
            "&accion_id=" +
            this.state.accion_id
        ).then((data) => {
          for (let d in data) {
            for (let rd in r.documentos) {
              if (r.documentos[rd].type === data[d].tipo_documento_id) {
                data[d].status = 3;
              }
            }
          }

          this.setState({
            nombres: r.nombres.toUpperCase(),
            apellido_paterno: r.apellido_paterno.toUpperCase(),
            apellido_materno: r.apellido_materno.toUpperCase(),
            codigo_ipsa: r.codigo_ipsa,
            numero_identificacion: r.numero_identificacion,
            direccion: r.direccion.toUpperCase(),
            correo_electronico: r.correo_electronico,
            telefono_celular: r.telefono_celular,
            telefono_convencional: r.telefono_convencional,
            tipo_regente: r.tipo_regente,
            professions: r.profesiones,
            departamento_id: r.departamento_id,
            municipio_id: r.municipio_id,
            tipo_documento_id: r.tipo_documento_id,
            documentos: r.documentos,
            docsRequired: data,
            recs: 0,
            solicitud_id: r.solicitud_id,
            regente_id: r.regente_id,
          });
          this.setState({ disabled: true });
          this.setState({
            recs: document.querySelectorAll("i.text-success").length,
          });
          Api.loading(false);
        });
      });
    }

    if (e.target.value === "3003") {
      //correccion
      Api.loading(true);
      Api.fetch(
        "app/getRegenteCorreccion?tramite_id=" + this.state.tramite_id
      ).then((r) => {
        this.setState({ tramite_id: r.tipo_regente });

        Api.fetch(
          "cat/getDocsPorTramite?tramite_id=" +
            r.tipo_regente +
            "&accion_id=" +
            r.accion_id
        ).then((data) => {
          if (data) {
            this.setState({ options_documents: data });
          }
        });

        /* Api.fetch(
          "cat/getDocsPorTramite?tramite_id=" +
            r.tipo_regente +
            "&accion_id=" +
            r.accion_id
        ).then((data) => {
          if (data) {
            this.setState({ options_documents: data });
          }
        }); */

        Api.fetch(
          "cat/getDocsObligatorios?tramite_id=" +
            r.tipo_regente +
            "&accion_id=" +
            r.accion_id
        ).then((data) => {
          for (let d in data) {
            for (let rd in r.documentos) {
              if (r.documentos[rd].type === data[d].tipo_documento_id) {
                data[d].status = 3;
              }
            }
          }

          this.setState({
            nombres: r.nombres.toUpperCase(),
            apellido_paterno: r.apellido_paterno.toUpperCase(),
            apellido_materno: r.apellido_materno.toUpperCase(),
            codigo_ipsa: r.codigo_ipsa,
            numero_identificacion: r.numero_identificacion,
            direccion: r.direccion.toUpperCase(),
            correo_electronico: r.correo_electronico,
            telefono_celular: r.telefono_celular,
            telefono_convencional: r.telefono_convencional,
            tipo_regente: r.tipo_regente,
            professions: r.profesiones,
            departamento_id: r.departamento_id,
            municipio_id: r.municipio_id,
            tipo_documento_id: r.tipo_documento_id,
            documentos: r.documentos,
            docsRequired: data,
            recs: 0,
            solicitud_id: r.solicitud_id,
            regente_id: r.regente_id,
          });

          this.setState({ disabled: true });

          this.setState({
            recs: document.querySelectorAll("i.text-success").length,
          });

          Api.loading(false);
        });
      });
    }

    if (e.target.value === "2002" || e.target.value === "3002") {
      //Baja o reposicion

      Api.fetch("app/getLicenciasRegente?tipo=" + this.state.tipo_regente).then(
        (l) => {
          this.setState({ licencias: l });
        }
      );

      const $codigoIPSA = document.getElementById("codigo_ipsa_input"),
        $btnIpsa = document.getElementById("codigo_ipsa_btn");
        //$iconIpsa = document.getElementById("codigo_ipsa_i");
        
      if(e.target.value === "2002" ){
        $codigoIPSA.setAttribute("disabled", true);
        $btnIpsa.className = "hide";
        //$btnIpsa.setAttribute("disabled", true);
        //$iconIpsa.setAttribute("disabled", true);
        this.setState({disabled: true});
      }else{
        $codigoIPSA.removeAttribute("disabled");
        $btnIpsa.className = "btn btn-outline-secondary form-control";
        //$btnIpsa.removeAttribute("disabled");
        //$iconIpsa.removeAttribute("disabled");
        this.setState({ disabled: false });
        if (e.target.value === "3003") this.handleCamposEditables(true);
      }
    }
  }

  handleCorrection(event) {
    event.preventDefault();

    if (this.state.tipo_regente === "1") {
      if (!this.state.codigo_ipsa) {
        this.handleValidationInput(
          "codigo_ipsa_input",
          "is-invalid",
          "invalid-feedback",
          "Ingrese código DISAAN."
        );

        Swal.fire({
          title: "Ingrese código DISAAN",
          icon: "warning",
          text: "El campo código DISAAN es obligatorio para el registro de regente de tipo veterinario.",
        });

        return false;
      }

      if (!this.state.codigo_ipsa_btn) {
        this.handleValidationInput(
          "codigo_ipsa_input",
          "is-invalid",
          "invalid-feedback",
          "Válide código DISAAN."
        );

        Swal.fire({
          title: "Código DISAAN no validado",
          icon: "warning",
          text: "Valide el código DISAAN.",
        });

        return false;
      }

      if (!this.state.codigo_ipsa_validado) {
        this.handleValidationInput(
          "codigo_ipsa_input",
          "is-invalid",
          "invalid-feedback",
          "Código DISAAN Inválido."
        );

        Swal.fire({
          title: "Código DISAAN inválido",
          icon: "warning",
          text: "Ingrese un código DISAAN válido.",
        });

        return false;
      }

      if (this.state.codigo_ipsa_existe) {
        this.handleValidationInput(
          "codigo_ipsa_input",
          "is-invalid",
          "invalid-feedback",
          "El código DISAAN ingresado ya se encuentra registrado y con licencia activa."
        );

        Swal.fire({
          title: "Código DISAAN ya registrado",
          icon: "warning",
          text: "El código DISAAN ingresado ya se encuentra registrado y con licencia activa.",
        });

        return false;
      }

      if (this.state.fecha_regente_vencida) {
        this.handleValidationInput(
          "codigo_ipsa_input",
          "is-invalid",
          "invalid-feedback",
          "Fecha de código DISAAN vencida."
        );

        Swal.fire({
          title: "Fecha de código DISAAN vencida",
          icon: "warning",
          text: "La fecha del código DISAAN ingresada es válida, pero se encuentra vencida actualmente.",
        });

        return false;
      }
    }

    if (this.state.recs < this.state.docsRequired.length) {
      Swal.fire({
        title: "Documentos Requeridos",
        icon: "warning",
        text: "Por favor revise la carga de documentos requeridos.",
      });
      return false;
    }

    this.setState({ procesando: true });

    //getting request ready for fetch (without options), must to be a shallow copy.
    let postData = { ...this.state };
    // shallow copy is inherit of the main state
    delete postData.options;
    delete postData.options_professions;
    delete postData.options_action;
    delete postData.options_documents;
    delete postData.options_identification;
    delete postData.options_regent;

    Api.fetch("app/updateRegentInscription", postData, "PUT")
      .then((data) => this.handleUpdate(data))
      .catch((error) => {
        error.json().then((message) => {
          this.setState({ procesando: false });
          Swal.fire({
            title: "Ocurrió un error al procesar la solicitud",
            icon: "error",
            text: "Revise la información e intente de nuevo su última acción.", //message,
          });
        }); //catching errors to show notification
      });
  }

  handleUpdate(e) {
    Swal.fire({
      title: "Solicitud Actualizada",
      icon: "success",
      text: "Su solicitud ha sido recibida exitosamente.",
    }).then(() => {
      window.location = "/tramites";
    });
    this.setState({ procesando: false });
  }

  handleProfesion(e) {
    this.setState({ professions: e });
  }

  handleIndentificacion(e) {
    this.setState({ tipo_documento_id: e.target.value });
  }

  handleTipoDocumento(e) {
    let dt = e.target.selectedIndex;
    this.setState({ document_type_temp: dt });
  }

  handleFile(e) {
    if (!parseInt(this.state.document_type_temp)) {
      Swal.fire({
        icon: "error",
        title: "Error...",
        text: "Debe seleccionar el tipo de documento primero.",
      });
      e.value = null;
      return;
    }

    let tipo_documento =
      this.state.options_documents[parseInt(this.state.document_type_temp) - 1];
    let existeDoc = this.state.documentos.find(
      (d) => d.type === tipo_documento.id.toString()
    );

    if (existeDoc) {
      Swal.fire({
        icon: "error",
        title: "Error...",
        text: "El tipo de documento ya ha sido adjuntado.",
      });
      e.value = null;
      return;
    }

    let file = e.files;
    let validExts = ["jpg", "jpeg", "png", "pdf"];
    let ext = file[0].type.split("/")[1];

    if (validExts.includes(ext)) {
      let imgReader = new FileReader();
      imgReader.react = this;

      let _react = this.state;
      let size = 0;
      imgReader.onloadend = function (a) {
        let tipo = _react.options_documents[_react.document_type_temp - 1];

        size = a.total;
        let dx = {
          data: imgReader.result,
          type: tipo.id,
          tipo: tipo.descripcion,
          ext: ext,
          file: file[0].name,
          key: _react.documentos.length,
          size: a.total,
        };

        for (let _docs in _react.documentos) {
          size = size + _react.documentos[_docs].size;
        }

        if (size >= 20000000) {
          Swal.fire({
            title: "Error",
            icon: "warning",
            text: "Se ha excedido de los 20MB permitidos de carga total.",
            confirmButtonText: "Continuar",
          });
          return;
        }

        _react.documentos[_react.documentos.length] = dx;

        // Si el documento que cargo esta como requerido marco su status
        let frecs = imgReader.react.state.docsRequired;

        for (let rec in frecs) {
          if (frecs[rec].descripcion === tipo.descripcion) {
            frecs[rec].status = 3;
            /* this.react.setState({
              recs: imgReader.react.state.recs + 1,
            });*/
          }
        }
        // Fin si el documento que cargo esta como requerido marco su status

        this.react.setState({
          documentos: _react.documentos,
        });

        this.react.setState({
          recs: document.querySelectorAll("i.text-success").length,
        });

        this.react = null;
        e.value = null;
      };
      imgReader.readAsDataURL(file[0]);
    } else {
      Swal.fire({
        icon: "error",
        title: "Error...",
        text: "Este tipo de documento no es admitido.",
      });
      e.value = null;
      return;
    }
  }

  autoRellenar(e) {
    Api.loading(1);
    Api.fetch("app/autoRellenarPersona").then((r) => {
      if (!r.licencia_regente_id) {
        document.querySelector("#nid").removeAttribute("disabled");
        document.querySelector("#tid").removeAttribute("disabled");
      }

      let apellido_materno = "";

      if (r.apellido_materno) {
        apellido_materno = r.apellido_materno.toUpperCase();
      }

      this.setState({
        nombres: r.nombres.toUpperCase(),
        apellido_paterno: r.apellido_paterno.toUpperCase(),
        apellido_materno: apellido_materno,
        correo_electronico: r.correo_electronico,
        telefono_celular: r.telefono_celular,
        departamento_id: r.departamento_id,
        municipio_id: r.municipio_id,
        direccion: r.direccion,
        numero_identificacion: r.numero_identificacion,
        tipo_documento_id: r.tipo_documento_id,
        telefono_convencional: r.telefono_convencional,
        solicitudes_aceptadas: r.solicitudes_aceptadas,
        solicitudes: r.solicitudes,
        autoFill: true,
        solicitudesLRV: r.solicitudesLRV,
        solicitudesLRA: r.solicitudesLRA,
        codigo_ipsa: r.codigo_ipsa
      });

      if (!r.tipo_documento_id) {
        document.querySelector("#nid").removeAttribute("disabled");
        document.querySelector("#tid").removeAttribute("disabled");
        document
          .querySelector("#telefono_convencional")
          .removeAttribute("disabled");
      }

      this.handleCamposEditables();
      Api.loading(0);
    });
  }

  handleLicencia(e) {
    this.setState({ disabled: true });
    let accion = 0;
    let id = e.target.value;

  /*  if (this.state.accion_id === "1" || this.state.accion_id === "2") {
      //alta o renovacion
      accion = 1;
    } else if (
      this.state.accion_id === "2002" ||
      this.state.accion_id === "3002"
    ) {
      //baja o reposicion
      accion = this.state.accion_id ;
    }*/
    
    accion = this.state.accion_id ;

    Api.fetch("app/getRegenteBaja?regente_id=" +
      e.target.value + 
      "&tipo_regente_id=" +
      + this.state.tipo_regente
      ).then((r) => {
      this.setState({ tramite_id: r.tipo_regente });
      Api.fetch(
        "cat/getDocsObligatorios",
        { tramite_id: r.tipo_regente, accion_id: accion },
        "POST"
      ).then((data) => {
        for (let d in data) {
          for (let rd in r.documentos) {
            if (r.documentos[rd].type === data[d].tipo_documento_id) {
              data[d].status = 3;
            }
          }
        }

        this.setState({
          nombres: r.nombres.toUpperCase(),
          apellido_paterno: r.apellido_paterno.toUpperCase(),
          apellido_materno: r.apellido_materno.toUpperCase(),
          codigo_ipsa: r.codigo_ipsa,
          numero_identificacion: r.numero_identificacion,
          direccion: r.direccion.toUpperCase(),
          correo_electronico: r.correo_electronico,
          telefono_celular: r.telefono_celular,
          telefono_convencional: r.telefono_convencional,
          tipo_regente: r.tipo_regente,
          professions: r.profesiones,
          departamento_id: r.departamento_id,
          municipio_id: r.municipio_id,
          tipo_documento_id: r.tipo_documento_id,
          tramite_id: r.tipo_regente,
          docsRequired: data,
          options_documents: data,
          recs: 0,
          regente_id: r.id,
        });
        this.setState({
          recs: document.querySelectorAll("i.text-success").length,
        });
      });
    });
    this.setState({ licencia_id: id });
  }

  handleSubmit(event) {
    event.preventDefault();

    if(this.state.accion_id !== "2002"){
      if (this.state.tipo_regente === "1") {
        if (!this.state.codigo_ipsa) {
          this.handleValidationInput(
            "codigo_ipsa_input",
            "is-invalid",
            "invalid-feedback",
            "Ingrese código DISAAN."
          );

          Swal.fire({
            title: "Ingrese código DISAAN",
            icon: "warning",
            text: "El campo código DISAAN es obligatorio para el registro de regente de tipo veterinario.",
          });

          return false;
        }

        if (!this.state.codigo_ipsa_btn) {
          this.handleValidationInput(
            "codigo_ipsa_input",
            "is-invalid",
            "invalid-feedback",
            "Válide código DISAAN."
          );

          Swal.fire({
            title: "Código DISAAN no validado",
            icon: "warning",
            text: "Valide el código DISAAN.",
          });

          return false;
        }

        if (!this.state.codigo_ipsa_validado) {
          this.handleValidationInput(
            "codigo_ipsa_input",
            "is-invalid",
            "invalid-feedback",
            "Código DISAAN Inválido."
          );

          Swal.fire({
            title: "Código DISAAN inválido",
            icon: "warning",
            text: "Ingrese un código DISAAN válido.",
          });

          return false;
        }

        if (this.state.codigo_ipsa_existe) {
          this.handleValidationInput(
            "codigo_ipsa_input",
            "is-invalid",
            "invalid-feedback",
            "El código DISAAN ingresado ya se encuentra registrado y con licencia activa."
          );

          Swal.fire({
            title: "Código DISAAN ya registrado",
            icon: "warning",
            text: "El código DISAAN ingresado ya se encuentra registrado y con licencia activa.",
          });

          return false;
        }

        if (this.state.fecha_regente_vencida) {
          this.handleValidationInput(
            "codigo_ipsa_input",
            "is-invalid",
            "invalid-feedback",
            "Fecha de código DISAAN vencida."
          );

          Swal.fire({
            title: "Fecha de código DISAAN vencida",
            icon: "warning",
            text: "La fecha del código DISAAN ingresada es válida, pero se encuentra vencida actualmente.",
          });

          return false;
        }
      }
    }

    if (this.state.recs < this.state.docsRequired.length) {
      Swal.fire({
        title: "Documentos Requeridos",
        icon: "warning",
        text: "Por favor revise la carga de documentos requeridos.",
      });
      return false;
    }

    Api.loading(1);

    //this.setState({ procesando: true });

    //getting request ready for fetch (without options), must to be a shallow copy.
    let postData = { ...this.state };

    // shallow copy is inherit of the main state
    delete postData.options;
    delete postData.options_professions;
    delete postData.options_action;
    delete postData.options_documents;
    delete postData.options_identification;
    delete postData.options_regent;

    Api.fetch("app/regentInscription", postData, "POST")
      .then((data) => this.handleRegister(data))
      .catch((error) => {
        error.json().then((message) => {
          this.setState({ procesando: false });
          Api.loading(0);
          Swal.fire({
            title: "Ocurrió un error al procesar la solicitud",
            icon: "error",
            text: "Revise la información e intente de nuevo su última acción", //message,
          });
        }); //catching errors to show notification
      });

    /*     Api.fetch("app/regentInscription", postData, "POST").then((r) => {
      postData["solicitud_id"] = r.solicitud_id;
      Api.fetch("app/createPayOrder", postData, "POST")
        .then((data) => this.handleRegister(data))
        .catch((error) => {
          error.json().then((message) => {
            this.setState({ procesando: false });
            Swal.fire({
              title: "Ocurrió un error al procesar la solicitud",
              icon: "error",
              text: "Revise la información e intente de nuevo su última acción", //message,
            });
          }); //catching errors to show notification
        });
    }); */
  }

  handleRegister(e) {
    if (e.errors) {
      let tplErrors = `Los siguientes campos son obligatorios: <u>`;

      for (let err in e.errors) {
        tplErrors += `<li>${err
          //.replace("_id", "")
          .replace("_", " ")
          .toUpperCase()}</li>`;
      }
      tplErrors += `</u>`;
      Swal.fire({
        title: "Atención, verifique el formulario",
        icon: "error",
        html: tplErrors,
      });
      Api.loading(0);
      return false;
    } else {
      Swal.fire({
        title: "Solicitud Generada",
        icon: "success",
        text: "Su solicitud ha sido recibida exitosamente.",
      }).then(() => {
        window.location = "/tramites";
      });
    }
    this.setState({ procesando: false });
  }

  handleReset(e) {
    this.setState({
      documentos: [],
    });
  }

  handleDelete(e) {
    Swal.fire({
      title: "Eliminar documento",
      text: "Esta acción eliminará el documento seleccionado de la carga.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      confirmButtonColor: "#4CD964",
      cancelButtonColor: "red",
      cancelButtonText: "Regresar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        let docs = [...this.state.documentos];
        // Verificamos si quitamos un documento requerido
        let frecs = [...this.state.docsRequired];
        for (let rec in frecs) {
          if (frecs[rec].descripcion === docs[e.target.id].tipo) {
            frecs[rec].status = 1;
            break;
          }
        }
        // fin verificacion

        docs.splice(e.target.id, 1);

        this.setState({
          documentos: docs,
        });

        let bandeja = document.querySelectorAll(".documentoCargado");
        for (let doc in bandeja) {
          if (!isNaN(doc)) {
            for (let rec in frecs) {
              if (
                bandeja[doc].attributes[0].value ===
                frecs[rec].tipo_documento_id
              ) {
                frecs[rec].status = 3;
              }
            }
          }
        }

        this.setState({ docsRequired: frecs });

        this.setState({
          recs: document.querySelectorAll("i.text-success").length,
        });
      }
    });
  }

  maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  cleanErrorsValidation(elemento) {
    let divMsg = document.getElementById(elemento + "-msg"),
      classValidation = document.getElementById(elemento);

    if (divMsg && classValidation) {
      divMsg.style.display = "none";
      divMsg.innerText = "";
      classValidation.classList.remove("is-invalid");
      classValidation.classList.remove("is-valid");
      divMsg.classList.remove("invalid-feedback");
      divMsg.classList.remove("valid-feedback");
    }
  }

  render() {
    const accion = this.state.accion_id;
    let submitButton;
    if (accion !== "3003") {
      //correccion
      submitButton = (
        <button type="submit" className="btn btn-success m-r-5">
          Generar
        </button>
      );
    } else {
      submitButton = (
        <button
          onClick={this.handleCorrection}
          className="btn btn-warning m-r-5"
        >
          Editar
        </button>
      );
    }

    /*   const tipo_regente = this.state.tipo_regente;
    if (tipo_regente === "2") {
      if (document.getElementById("codigo_ipsa") !== null) {
        document.getElementById("codigo_ipsa").remove();
      }
    } */

    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/solicitud/inscripcion-regente">Solicitud</Link>
          </li>
          <li className="breadcrumb-item active">Inscripción Regente</li>
        </ol>
        <h1 className="page-header">Solicitud de inscripción de regente</h1>

        <div className="row" onSubmit={this.handleSubmit}>
          <div className="col-md-12">
            <Panel>
              <PanelBody>
                <form style={{ margin: "3%" }}>
                  <div className="alert alert-info hide" role="alert">
                    <input
                      name="isGoing"
                      type="checkbox"
                      value={this.state.isGoing || false}
                      checked={this.state.isGoing || false}
                      onChange={this.autoRellenar}
                      disabled={this.state.disabled}
                    />

                    <span>
                      {" "}
                      Seleccione si desea utilizar la información del perfil de
                      usuario para auto rellenar.
                    </span>
                  </div>
                  <div className="form-group row col-md-9">
                    <label className="col-form-label col-md-3">
                      Tipo regente: <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-9">
                      <select
                        onChange={this.handleTipoRegente}
                        name="tipo_regente_id"
                        className="form-control m-b-5"
                        value={this.state.tipo_regente_id}
                        disabled={this.state.disabled}
                        id={this.state.tipo_regente_id}
                      >
                        <option value="0" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_regent.tipo_regente.map(
                          (option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                  </div>
                  <div className="form-group row col-md-9">
                    <label className="col-form-label col-md-3">
                      Tipo solicitud: <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-9">
                      <select
                        onChange={this.handleTipoAccion}
                        className="form-control m-b-5"
                        value={this.state.accion_id}
                      >
                        <option value="0" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_action.map((option) => (
                          <option
                            className="dropdown-item"
                            name={option.label}
                            key={option.value}
                            value={option.value}
                            disabled={option.isDisabled}
                          >
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div
                    id="codigo_ipsa"
                    className={
                      this.state.tipo_regente === "1" && this.state.accion_id !== ""
                        ? "form-group row col-md-9"
                        : "form-group row col-md-9 hide"
                    }
                  >
                    <label className="col-form-label col-md-3">
                      Código disaan: <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-9 input-group">
                      <input
                        type="text"
                        id="codigo_ipsa_input"
                        name="codigo_ipsa"
                        //id="codigoIPSA"
                        value={this.state.codigo_ipsa}
                        onChange={(e) => {
                          this.cleanErrorsValidation("codigo_ipsa_input");
                          this.setState({
                            codigo_ipsa: e.target.value,
                            codigo_ipsa_existe:
                              this.initialState.codigo_ipsa_existe,
                            codigo_ipsa_validado:
                              this.initialState.codigo_ipsa_validado,
                            codigo_ipsa_btn: this.initialState.codigo_ipsa_btn,
                            fecha_regente_vencida:
                              this.initialState.fecha_regente_vencida,
                          });
                        }}
                        disabled={false}
                        className="form-control m-b-5"
                        placeholder=""
                      />
                      <div className="input-group-append">
                        <button
                          id="codigo_ipsa_btn"
                          onClick={this.verifyCodigoIPSA}
                          className="btn btn-outline-secondary form-control"
                          type="button"
                          disabled={false}
                        >
                          <i id="codigo_ipsa_i" className="fas fa-search" disabled={false}></i>
                        </button>
                      </div>
                      <div
                        // className="invalid-feedback"
                        style={{ display: "none" }}
                        id="codigo_ipsa_input-msg"
                      ></div>
                    </div>
                  </div>
                  {this.state.accion_id === "2002" ||
                  this.state.accion_id === "4" ? (
                    <div className="form-group row col-md-9">
                      <div
                        className="alert alert-danger col-md-12"
                        role="alert"
                      >
                        Favor de verificar si es la licencia deseada.
                      </div>

                      <label className="col-form-label col-md-3">
                        Licencias: <span className="text-danger">*</span>
                      </label>
                      <div className="col-md-9">
                        <select
                          onChange={this.handleLicencia}
                          className="form-control m-b-5"
                          value={this.state.licencia_id}
                        >
                          <option value="0" className="dropdown-item">
                            Seleccione...
                          </option>
                          {this.state.licencias.map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion_t} [{option.folio_licencia}]
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  ) : null}
                  <div className="form-group row col-md-9">
                    <label className="col-form-label col-md-3">
                      Profesión: <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-9">
                      <Select
                        isMulti
                        styles={colourStyles}
                        placeholder="Seleccione"
                        onChange={this.handleProfesion}
                        theme="neutral40"
                        value={this.state.professions}
                        options={this.state.options_professions}
                        getOptionLabel={(option) => option.descripcion}
                        getOptionValue={(option) => option.id}
                        noOptionsMessage={() => "No se encontraron profesiones"}
                        isDisabled={this.state.disabled}
                      />
                    </div>
                  </div>
                  <div className="form-group row col-md-9">
                    <label className="col-form-label col-md-3">
                      Nombre(s): <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        name="nombres"
                        value={this.state.nombres}
                        onChange={(e) =>
                          this.setState({
                            nombres: e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        placeholder="Nombre(s)"
                        disabled={this.state.disabled || this.state.autoFill}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group row col-md-9">
                    <label className="col-form-label col-md-3">
                      Apellido paterno: <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        name="apellido_paterno"
                        value={this.state.apellido_paterno}
                        onChange={(e) =>
                          this.setState({
                            apellido_paterno: e.target.value.toUpperCase(),
                          })
                        }
                        disabled={this.state.disabled || this.state.autoFill}
                        className="form-control m-b-5"
                        placeholder="Apellido paterno"
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group row col-md-9">
                    <label className="col-form-label col-md-3">
                      Apellido materno:
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        name="apellido_materno"
                        value={this.state.apellido_materno}
                        onChange={(e) =>
                          this.setState({
                            apellido_materno: e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        placeholder="Apellido materno"
                        disabled={this.state.disabled || this.state.autoFill}
                        //required
                      />
                    </div>
                  </div>
                  <div className="form-group row col-md-9">
                    <label className="col-form-label col-md-3">
                      Tipo de identificación:{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-9">
                      <select
                        onChange={this.handleIndentificacion}
                        name="identificacion_id"
                        className="form-control m-b-5"
                        value={this.state.tipo_documento_id}
                        id="tid"
                        disabled={this.state.disabled || this.state.autoFill}
                      >
                        <option value="0" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options_identification.tipo_identificacion.map(
                          (option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                  </div>
                  <div className="form-group row col-md-9">
                    <label className="col-form-label col-md-3">
                      Número de identificación:{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        name="numero_identificacion"
                        id="nid"
                        maxLength="50"
                        value={this.state.numero_identificacion}
                        onChange={this.handleNumIdentificacion}
                        disabled={
                          this.state.disabled ||
                          this.state.autoFill ||
                          this.state.licenciaValida
                        }
                        className="form-control m-b-5"
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group row col-md-9">
                    <label className="col-form-label col-md-3">
                      Departamento: <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-9">
                      <select
                        onChange={this.handleDepartamentos}
                        name="departamento_id"
                        className="form-control m-b-5"
                        value={this.state.departamento_id}
                        disabled={this.state.disabled || this.state.autoFill}
                      >
                        <option value="0" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options.departamentos.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="form-group row col-md-9">
                    <label className="col-form-label col-md-3">
                      Municipio: <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-9">
                      <select
                        onChange={this.handleMunicipios}
                        name="municipio_id"
                        className="form-control m-b-5"
                        value={this.state.municipio_id}
                        disabled={this.state.disabled || this.state.autoFill}
                      >
                        <option value="0" className="dropdown-item">
                          Seleccione...
                        </option>
                        {this.state.options.municipios
                          .filter(
                            (e) => e.estado_id === this.state.departamento_id
                          )
                          .map((option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="form-group row col-md-9">
                    <label className="col-form-label col-md-3">
                      Dirección: <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        id="direccion"
                        name="direccion"
                        value={this.state.direccion}
                        onChange={(e) =>
                          this.setState({
                            direccion: e.target.value.toUpperCase(),
                          })
                        }
                        className="form-control m-b-5"
                        placeholder=""
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group row col-md-9">
                    <label className="col-form-label col-md-3">
                      Correo electrónico activo:{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-9">
                      <input
                        type="email"
                        name="correo_electronico"
                        value={this.state.correo_electronico}
                        onChange={(e) =>
                          this.setState({ correo_electronico: e.target.value })
                        }
                        disabled={this.state.disabled || this.state.autoFill}
                        className="form-control m-b-5"
                        placeholder="Correo electrónico"
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group row col-md-9">
                    <label className="col-form-label col-md-3">
                      Teléfono convencional activo:{" "}
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        name="telefono_convencional"
                        id="telefono_convencional"
                        value={this.state.telefono_convencional}
                        onChange={this.handleTelefonoConvencional}
                        // maxLength="8"
                        // onInput={this.maxLengthCheck}
                        disabled={this.state.disabled || this.state.autoFill}
                        className="form-control m-b-5"
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div className="form-group row col-md-9">
                    <label className="col-form-label col-md-3">
                      Teléfono celular activo:{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        name="telefono_celular"
                        value={this.state.telefono_celular}
                        onChange={this.handleTelefonoCelular}
                        // maxLength="8"
                        // onInput={this.maxLengthCheck}
                        disabled={this.state.disabled || this.state.autoFill}
                        className="form-control m-b-5"
                        placeholder=""
                        required
                      />
                    </div>
                  </div>
                  <h4 className="m-b-10">
                    Adjuntar documentación requerida ({this.state.recs} de{" "}
                    {this.state.docsRequired.length}):
                  </h4>{" "}
                  <h6>
                    <i>
                      *Los tipos extensión de los documentos que se admiten son:
                      ".jpg", ".jpeg", ".png" y ".pdf"{" "}
                    </i>
                  </h6>
                  <ol>
                    {this.state.docsRequired.map((doc, index) => (
                      <li key={index}>
                        <i
                          className={
                            doc.status === 3
                              ? "far fa-check-square text-success"
                              : "far fa-square"
                          }
                        ></i>{" "}
                        {doc.descripcion}{" "}
                        {doc.entrega_original === 1
                          ? " - Además presentar original* "
                          : ""}
                      </li>
                    ))}
                  </ol>
                  {this.state.documentos.map((document, index) => (
                    <div
                      key={document.key}
                      data-tipo={document.type}
                      className="note note-primary documentoCargado"
                    >
                      <div className="note-icon">
                        <i
                          className={
                            document.ext === "pdf"
                              ? "fas fa-file-pdf"
                              : "fas fa-file-image"
                          }
                        ></i>
                      </div>
                      <div className="note-content">
                        <h4>
                          <b>{document.tipo}</b>
                        </h4>
                        <p> {document.file} </p>
                      </div>
                      <div className="pull-right">
                        <i
                          onClick={this.handleDelete}
                          id={index}
                          className="ion ion-md-close-circle fa-2x fa-fw pull-left m-r-10 text-red"
                        ></i>
                      </div>
                    </div>
                  ))}
                  <hr />
                  <div className="form-group row col-md-10">
                    <label className="col-form-label col-md-6">
                      <select
                        onChange={this.handleTipoDocumento}
                        name="documento_id"
                        className="form-control m-b-5"
                      >
                        <option className="dropdown-item" value="0">
                          Seleccione tipo de documento...
                        </option>

                        {this.state.options_documents.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.descripcion}
                          </option>
                        ))}
                      </select>
                    </label>

                    <div className="col-md-4" style={{ marginTop: "0.7%" }}>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={(e) => hiddenFileInput.current.click()}
                      >
                        Seleccionar archivo
                      </button>
                      <input
                        type="file"
                        accept=".jpg,.jpeg,.png,.pdf"
                        ref={hiddenFileInput}
                        onChange={(e) => this.handleFile(e.target)}
                        style={{ display: "none" }}
                      />
                    </div>
                  </div>
                  <hr />
                  <div
                    className={
                      this.state.procesando
                        ? "progress rounded-corner m-b-15"
                        : "hide"
                    }
                  >
                    <div
                      className="progress-bar bg-purple progress-bar-striped progress-bar-animated"
                      style={{ width: "100%", height: "20px" }}
                    >
                      <h4>Cargando, espere...</h4>
                    </div>
                  </div>
                  <div
                    className={this.state.procesando ? "hide" : "pull-right"}
                  >
                    <div style={{ marginBottom: "10%" }}>{submitButton}</div>
                  </div>
                </form>
              </PanelBody>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  return <RegentInscription auth={auth} history={history} {...props} />;
};
